import React from "react";

const ArrowDownIcon = (props) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M7 10L11.2318 15.0781C11.6316 15.5579 12.3684 15.5579 12.7682 15.0781L17 10"
				stroke="#EFF0F6"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</svg>
	);
};

export default ArrowDownIcon;
